/*
 * File: index.ts
 * Author: Austin Robinson
 * Date Created: 9/10/2022
 * Copyright (c) DrivingDoc 2022
 */
import { useState } from 'react';

import { useCreateCoursePeriods } from 'api/hooks/private/periods/CreateCoursePeriods.ts';
import { useDeleteCoursePeriods } from 'api/hooks/private/periods/DeleteCoursePeriods.ts';
import { GetAllCoursePeriodsParams, useGetAllCoursePeriods } from 'api/hooks/private/periods/GetAllCoursePeriods.ts';
import { useGetInstructors } from 'api/hooks/private/users/instructors/GetInstructors.ts';

export default function useCalendarData() {
  const [calendarFilter, setCalendarFilter] = useState<GetAllCoursePeriodsParams | undefined>(undefined);

  const { data: instructors } = useGetInstructors({
    variables: {
      status: 'both',
    },
  });

  const { data: coursePeriods } = useGetAllCoursePeriods({
    variables: calendarFilter,
  });

  const submitNewDrives = useCreateCoursePeriods();

  const deleteCoursePeriodsMutation = useDeleteCoursePeriods();

  // const registerStudentsForDrive = useMutation(async ({ driveID, studentIDs }: RegisterStudentParams) => {
  //   // const mutationParams = {
  //   //   input: {
  //   //     driveID,
  //   //     studentID: studentIDs[0], // todo temp while using one student
  //   //     canceled: false,
  //   //   },
  //   // };
  //   // const newRegistration = (API.graphql(graphqlOperation(createStudentDrive, mutationParams)) as any);
  //   // return newRegistration;
  //   const temp = undefined;
  //   return temp as any;
  // });

  return {
    calendarFilter: calendarFilter,
    setCalendarFilter,
    instructors: instructors,
    coursePeriods: coursePeriods,
    submitNewDrives,
    deleteCoursePeriodsMutation,
    // registerStudentsForDrive,
  };
}
